import React from 'react';
import { getFileUploadPolicy, getAcceptFromPolicy } from "../Utils/fileUploadPolicy";

export const useFileUploadPolicy = () => {
    const [policy, setPolicy] = React.useState(null);
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState(null);

    const refresh = React.useCallback(async (force = false) => {
        setLoading(true);
        setError(null);
        try {
            const p = await getFileUploadPolicy(force);
            setPolicy(p);
            return p;
        } catch (e) {
            setError(e);
            return null;
        } finally {
            setLoading(false);
        }
    }, []);

    React.useEffect(() => {
        refresh(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const accept = React.useMemo(() => getAcceptFromPolicy(policy), [policy]);

    return { policy, accept, loading, error, refresh };
};

export default useFileUploadPolicy;

















